import _assign from 'lodash/assign'
import _cloneDeep from 'lodash/cloneDeep'
import _get from 'lodash/get'
import _map from 'lodash/map'
import { get as apiGet, TYPE_BROOKLYN_JSON } from '../../api-client/index'
import { createModel as createTileModel } from '../tile/index'

export const DEFAULT_LIMIT = 16

const SCHEMA = {
  id: null,
  uid: null,
  _dataError: null,
  processing: false,
  titles: [],
}

export async function get (options) {
  const {
    id,
    uid,
    auth,
    xff,
    limit = DEFAULT_LIMIT,
    page = 0,
    language,
    country,
    usePGV = false, // Remove this once AI related testing is done
  } = options
  // const rType = _get(query, 'rType')

  // if (rType && rType === 'pgv') {
  //   usePGV = true
  // }

  try {
    const res = await apiGet(
      `v2/videos/${id}/related`,
      {
        p: page, pp: limit, language, country, usePGV,
      },
      { auth, xff },
      TYPE_BROOKLYN_JSON,
    )
    return handleRelatedResponse(res, id, uid)
  } catch (e) {
    return handleRelatedResponse({}, id, uid, true)
  }
}

function handleRelatedResponse (res, id, uid, _dataError) {
  const data = _get(res, 'body', {})
  return createModel(data, id, uid, _dataError)
}

function createModel (data, id, uid, _dataError) {
  const titles = _map(_get(data, 'titles', []), (tile) => createTileModel(tile))
  return _assign(_cloneDeep(SCHEMA), {
    id,
    _dataError,
    uid,
    titles,
  })
}

function handleRelatedContentResponse (res, _dataError) {
  const { body } = res
  const related = _get(body, ['contentReferences', 'toContent'], [])
  return {
    _dataError,
    success: !_dataError,
    data: related,
  }
}

export async function getRelatedContent (options) {
  const {
    contentId,
    contentType,
    contentReferenceType,
    auth,
  } = options

  if (!contentId) {
    throw new Error('A contentId is required.')
  }

  if (!contentType) {
    throw new Error('A contentType is required.')
  }

  const params = {
    fromContent: [{
      contentId,
      contentType,
    }],
    ...(contentReferenceType) && { fromContentContentReferenceType: contentReferenceType },
  }

  try {
    const res = await apiGet(
      'v1/content/related',
      params,
      { auth },
      TYPE_BROOKLYN_JSON,
    )
    return handleRelatedContentResponse(res)
  } catch (e) {
    return handleRelatedContentResponse({}, true)
  }
}
